'use client';

import { Duration, intervalToDuration } from 'date-fns';
import { useEffect, useState } from 'react';
import clsx from 'clsx';

export function Countdown({
  endDate,
  className,
  countdownClass,
  boxClass,
  t = { days: ':', hours: ':', minutes: ':', seconds: '' },
}: {
  endDate: Date;
  className?: string;
  countdownClass?: string;
  boxClass?: string;
  t?: { days: string; hours: string; minutes: string; seconds: string };
}) {
  const [countdown, setCountdown] = useState<Duration>({
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(() => intervalToDuration({ start: new Date(), end: endDate }));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={clsx('flex', className)}>
      <div className={boxClass}>
        <span className={clsx('countdown font-mono', countdownClass)}>
          <span style={{ '--value': countdown.days } as React.CSSProperties} />
        </span>
        {t.days}
      </div>
      <div className={boxClass}>
        <span className={clsx('countdown font-mono', countdownClass)}>
          <span style={{ '--value': countdown.hours } as React.CSSProperties} />
        </span>
        {t.hours}
      </div>
      <div className={boxClass}>
        <span className={clsx('countdown font-mono', countdownClass)}>
          <span style={{ '--value': countdown.minutes } as React.CSSProperties} />
        </span>
        {t.minutes}
      </div>
      <div className={boxClass}>
        <span className={clsx('countdown font-mono', countdownClass)}>
          <span style={{ '--value': countdown.seconds } as React.CSSProperties} />
        </span>
        {t.seconds}
      </div>
    </div>
  );
}
